import React, { Component } from 'react'
import { connect } from 'react-redux'
import shortid from 'shortid';
import $ from 'jquery'
import './Button.css';

import {
   hideTooltip
} from '../../actions/actions.export.js'

class Button extends Component {
  constructor(props){
    super(props);

    this.state = {
      id: shortid.generate(),
      display: props.display,
      disabled: props.disabled,
      thinking: props.thinking || false,
      successful: props.successful || false,
      failed: props.failed || false,
      lastSuccessful: false,
      lastFailed: false,
      size: props.size || 'normal',
      block: props.block || false,
      color: props.color,
      icon: props.icon,
      fixedWidth: props.fixedWidth,
      block: props.block
    }

    this.clickHandler = this.clickHandler.bind(this);
  }

  componentDidMount(){
    if(this.state.successful){
      if(new Date().getTime() - this.state.successful < 2000){
        setTimeout((e) => {
          this.setState({
            successful: false,
            lastSuccessful: this.state.successful
          })
        }, 1000)
      } else {
        this.setState({
          successful: false,
          lastSuccessful: this.state.successful
        })
      }
    }
    if(this.state.failed){
      if(new Date().getTime() - this.state.failed < 2000){
        setTimeout((e) => {
          this.setState({
            failed: false,
            lastFailed: this.state.failed
          })
        }, 500)
      } else {
        this.setState({
          failed: false,
          lastFailed: this.state.failed
        })
      }
    }
  }

  componentWillReceiveProps(newProps){

    this.setState({
      display: newProps.display,
      disabled: newProps.disabled || false,
      thinking: newProps.thinking || false,
      successful: newProps.successful > this.state.lastSuccessful ? newProps.successful : false,
      failed: newProps.failed > this.state.lastFailed ? newProps.failed : false,
      size: newProps.size || 'normal',
      color: newProps.color,
      icon: newProps.icon,
      fixedWidth: newProps.fixedWidth,
      block: newProps.block
    })

    if(newProps.successful > this.state.lastSuccessful && new Date().getTime() - newProps.successful < 2000){
      setTimeout((e) => {
        this.setState({
          successful: false,
          lastSuccessful: newProps.successful
        })
      }, 1000)
    }

    if(newProps.failed > this.state.lastFailed && new Date().getTime() - newProps.failed < 2000){
      setTimeout((e) => {
        this.setState({
          failed: false,
          lastFailed: newProps.failed
        })
      }, 500)
    }
  }

  clickHandler(){
    if(!this.state.disabled){
      if(this.props.onClick && !this.props.submit){
        // prevent double firing w/ submits
        this.props.onClick();
      }
      if(this.props.submit){
        document.getElementById("submit-" + this.state.id).click();
      }
    }
  }

  render(){
    const { dispatch } = this.props; 

    const state = this.state;
    const props = this.props;

    let classes = (state.size === 'large' ? " button-lg" : "") + 
        (state.size === 'medium' ? " button-md" : "") + 
        (state.size === 'small' ? " button-sm" : "") + 
        (state.size === 'thin' ? " button-thin" : "") + 
        (state.size === 'normal' ? " button-normal" : "") + 
        (state.size === 'squared-normal' ? " button-squared-normal" : "") + 
        (state.size === 'header' ? " button-header" : "") + 
        (state.size === 'header-icon' ? " button-header-icon" : "") + 
        (state.fixedWidth ? " fixed-width" : "") + 
        (state.color ? (" button-" + state.color) : "") +
        (props.hoverTextColor ? (" button-hover-text-" + props.hoverTextColor) : "") +
        (state.block ? " button-block" : "") + 
        (this.props.dropdown ? " button-dropdown" : "") +
        (this.props.dropdownOnly ? " button-no-click": "") +
        (this.props.spaceBetween ? " button-space-between" : "");


    let dropdown = this.props.dropdown

    return <div className={"button-container " + (state.block ? "button-container-block" : "")}>
      <div 
        className={"button " + (state.disabled ? 'button-disabled ' : '') + (state.thinking ? " button-thinking" : "")  + (state.successful ? " button-successful" : "")}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        >
        { 
          (this.props.submit && !state.disabled) && <button id={"submit-" + this.state.id} disabled={state.disabled} type="submit" style={{display: 'none'}}/> 
        }

        {
          state.thinking ? 
          (
            props.thinkingDisplay ? 
            <div className={"button-wrapper " + classes} onClick={this.clickHandler} onMouseDown={this.props.onMouseDown}>
              <span className="button-display">{props.thinkingDisplay}</span>
            </div>
           : 
            <div className={"button-wrapper " + classes} onClick={this.clickHandler} onMouseDown={this.props.onMouseDown}>
              <span style={{opacity: 0}}>{state.display}</span>
              <div className="button-centered-icon">
                <i className="fas fa-spinner-third fa-spin fa-lg"/>
              </div>
            </div>
          )
          : 
          state.successful ?
          (
            props.successfulDisplay ? 
            <div className={"button-wrapper " + classes} onClick={this.clickHandler} onMouseDown={this.props.onMouseDown}>
              <span className="button-display">{props.successfulDisplay}</span>
            </div>
           : 
            <div className={"button-wrapper " + classes} onClick={this.clickHandler} onMouseDown={this.props.onMouseDown}>
              <span style={{opacity: 0}}>{state.display}</span>
              <div className="button-centered-icon">
                <i className="fas fa-check fa-lg"/>
              </div>
            </div>
          )
          : 
          state.failed ?
          (
            props.failedDisplay ? 
            <div className={"button-wrapper " + classes} onClick={this.clickHandler} onMouseDown={this.props.onMouseDown}>
              <span className="button-display">{props.failedDisplay}</span>
            </div>
           : 
            <div className={"button-wrapper " + classes} onClick={this.clickHandler} onMouseDown={this.props.onMouseDown}>
              <span className="shaking-no">{state.display}</span>
            </div>
          )
          : 
          (
            state.icon ? (
              <div className={"button-wrapper " + classes} key={shortid.generate()} onClick={this.clickHandler} onMouseDown={this.props.onMouseDown}>
                <span className="button-display">{state.display}</span>
                <i className={"button-icon " + state.icon}/>
              </div>
            ) : (
              props.dropdownOnly != true &&
              <div className={"button-wrapper " + classes} onClick={this.clickHandler} onMouseDown={this.props.onMouseDown}>
                <span>{state.display}</span>
              </div>
            )
          )
        }
        {
          dropdown && <div className="dropdown">
            <a className={"dropdown-toggle " + classes} href="#" role="button" id={"btn-" + state.id} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              { 
                this.props.dropdownOnly ? <span>{this.state.display} </span> : ""
              }
              {this.props.dropdownIcon ?  this.props.dropdownIcon : <i className="far fa-fw fa-angle-down"/>}
            </a>

            <div className={"dropdown-menu dropdown-menu-" + (this.props.dropdownDirection ? this.props.dropdownDirection : "right")} aria-labelledby={"btn-" + state.id} onMouseEnter={(e)=>{ dispatch(hideTooltip()) }}>
              {dropdown.map((d,i)=>{
                return <div key={i}>{d}</div>
              })}
            </div>
          </div>
        }
      </div>
    </div>
  }
}

const mapStateToProps = (state) => {
  // const { / } = state;

  return {
    // ...
  }
}

export default connect(mapStateToProps)(Button);



// WEBPACK FOOTER //
// ./src/components/Button/Button.js